import * as React from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';

import * as style from './RegionsButton.css';

export interface IRegionsButtonProps {
  onClick?: () => void;
  children: string;
}

export const RegionsButton: React.FC<IRegionsButtonProps> = props => {
  const { children, onClick } = props;
  const deviceType = useDeviceType();
  const buttonSize = React.useMemo(() => (deviceType === 'phone' ? 'M' : 'XS'), [deviceType]);
  const fullWidth = React.useMemo(() => deviceType === 'phone', [deviceType]);

  return (
    <div className={style['container']}>
      <Button
        fullWidth={fullWidth}
        onClick={onClick}
        size={buttonSize}
        theme="stroke_secondary"
        data-testid="RegionsButton"
      >
        {children}
      </Button>
    </div>
  );
};
